import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { AssociadoAuthLocalStorageNames } from 'enuns/AssociadoAuthLocalStorageNames';
import { Consulta, PrivateMain } from 'pages';
import React, { useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { authActionsLogin, authActionsLoginByToken } from 'store/modules/AuthActions';
import { IReducer } from 'store/Reducer';
import { getAssociadoLocalStorageAccessToken } from 'utils/AssociadoAuthUtils';
import { getWSO2LocalStorageAccessToken, getWSO2LocalStorageIdToken } from 'utils/WSO2AuthUtils';

export default () => {
  const reducerState: IReducer = useStore().getState();
  const reduxDispatch = useDispatch();
  const wso2AccessToken = getWSO2LocalStorageAccessToken();
  const wso2IdToken = getWSO2LocalStorageIdToken();
  const associadoAccessToken = getAssociadoLocalStorageAccessToken();
  const [wso2LoginFailed, setWso2LoginFailed] = useState<boolean>(false);
  const [associadoLoginFailed, setAssociadoLoginFailed] = useState<boolean>(false);

  if (reducerState.auth.usuario && reducerState.auth.logged) {
    return <PrivateMain />;
  } else {
    if (!associadoLoginFailed && associadoAccessToken) {
      reduxDispatch(
        authActionsLogin(
          associadoAccessToken,
          () => {
            // logando com associado
          },
          () => {
            window.localStorage.removeItem(AssociadoAuthLocalStorageNames.AccessToken);
            setAssociadoLoginFailed(true);
          }
        )
      )
      return <LoadingScreen />
    }
    if (!wso2LoginFailed && wso2AccessToken && wso2IdToken) {
      reduxDispatch(
        authActionsLoginByToken(
          wso2AccessToken,
          wso2IdToken,
          () => {
            // logando ...
          },
          () => {
            window.localStorage.clear();
            setWso2LoginFailed(true);
          }
        )
      );
      return <LoadingScreen />
    }
    return <Consulta />;
  }
}